import React from 'react';
import {
  Link,
} from "react-router-dom";

function HeaderView() {
    // use for pages where you don't want to display default header
    // const location = useLocation();
    // if ( location.pathname == '/subscribe' ) return null;

    return (
        <div className={'header-container'}>
            <Link to="/">
                <img 
                    src={require("../../assets/logo.png")} 
                    className={'main-logo'}
                />
            </Link>
            <ul className={'menu-items'}>
                <li className={'menu-item'}>
                    <Link to="/">Home</Link>
                </li>
                {/* <li className={'menu-item'}>
                    <a href="">Categories</a>
                </li> */}
                { /*
                <li className={'menu-item alt'}>
                    <a className={'alt-item'}>
                        Sign Up
                    </a>
                </li>
                */ }
            </ul>
        </div>
    );
}

export default HeaderView;
